export default __webpack_public_path__ + "static/media/G0570.34I-26321_-17334_0.1666265400000.34098b59.jpg";